import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';

import { API_QUERY_KEYS, updateConsultee } from 'api';
import { UpdateAdminUserRequest } from '../types';

export const useUpdateAdminUser = (): UseMutationResult<
  unknown,
  unknown,
  UpdateAdminUserRequest
> => {
  const queryClient = useQueryClient();
  return useMutation(updateConsultee, {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [API_QUERY_KEYS.getTQAdmins] });
      queryClient.invalidateQueries({ queryKey: [API_QUERY_KEYS.getManageConsultees] });
    },
  });
};
